import { render, staticRenderFns } from "./BaseSalary.vue?vue&type=template&id=70066052"
import script from "./BaseSalary.vue?vue&type=script&lang=js"
export * from "./BaseSalary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports